import { Link } from "react-router-dom";

function LinkButton({ url, Icon, size, className, text }) {
  return (
    <Link to={url} className={className}>
      <Icon size={size} />
      {text}
    </Link>
  );
}
export default LinkButton;
